export const state = () => ({
  productId: -1,
  initSelectedVariants: []
})

export const mutations = {

  // Запись аккаунта профиля My Acuvue
  setProductId: function(state, productId) {
    state.productId = productId;
  },

  setProductInitSelectedVariants: function (state, initSelectedVariants) {
    state.initSelectedVariants = initSelectedVariants;
  }

}
